module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests.77004b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests.jpg
// module id = 2889
// module chunks = 11